import type { RouteObject } from 'react-router';

import { Suspense } from 'react';
import { Outlet } from 'react-router';

import lazyWithReload from 'src/utils/lazyWithReload';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import { usePathname } from '../../../routes/hooks';

// Lazy load pages
const DialerCampaignListPage = lazyWithReload(() => import('src/pages/dialer-campaign/list'));
const DialerCampaignCreateEditPage = lazyWithReload(
  () => import('src/pages/dialer-campaign/create-edit')
);
const DialerCampaignDetailPage = lazyWithReload(() => import('src/pages/dialer-campaign/detail'));

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const dialerCampaignRoutes: RouteObject[] = [
  {
    path: 'dialer-campaign',
    element: CONFIG.auth.skip ? dashboardLayout() : <AuthGuard>{dashboardLayout()}</AuthGuard>,
    children: [
      { index: true, element: <DialerCampaignListPage /> },
      { path: 'create', element: <DialerCampaignCreateEditPage /> },
      { path: ':id/edit', element: <DialerCampaignCreateEditPage /> },
      { path: ':id/details', element: <DialerCampaignDetailPage /> },
    ],
  },
];
